<template>
    <div class="reg-container">
        <TitlePart text="Important Dates" />
        <div class="left-aligned-text" style="line-height: 150%">
            <ul style="line-height: 150%">
                <li class="left-aligned-text">
                    Early bird registration lasts until 1st Sep, 2024.
                </li>
                <li class="left-aligned-text">
                    Presenter registration will end on Oct 10, 2024.
                </li>
            </ul>
            <br />
            <br />
        </div>
        <TitlePart text="Registration Categories and Fee" />
        <div class="table-responsive">
            <table class="table table-striped table-bordered custom-table itable" >
                <thead>
                    <tr>
                        <th>Categories</th>
                        <th>On or before 1st Sep, 2024</th>
                        <th>After 1st Sep, 2024</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Full delegate</td>
                        <td>3200 HKD</td>
                        <td>4000 HKD</td>
                    </tr>
                    <tr>
                        <td>Student delegate</td>
                        <td>1600 HKD</td>
                        <td>2000 HKD</td>
                    </tr>
                    <tr>
                        <td>Least developed countries *</td>
                        <td>1600 HKD</td>
                        <td>2000 HKD</td>
                    </tr>
                    <tr>
                        <td>Senior participant **</td>
                        <td>2600 HKD</td>
                        <td>3200 HKD</td>
                    </tr>
                    <tr>
                        <td>Daily delegate</td>
                        <td>1800 HKD</td>
                        <td>2200 HKD</td>
                    </tr>
                    <tr>
                        <td>Government delegate</td>
                        <td>-</td>
                        <td>2600 HKD</td>
                    </tr>
                    <tr>
                        <td>Accompanying person</td>
                        <td>800 HKD</td>
                        <td>1000 HKD</td>
                    </tr>
                    <tr>
                        <td>Gala dinner</td>
                        <td colspan="2">600 HKD</td>
                    </tr>
                    <tr>
                        <td>Workshop</td>
                        <td>Free</td>
                        <td>TBD</td>
                    </tr>
                </tbody>
            </table>
            <br>
            <p style="text-align: left;">
                * Persons from countries on <a href="https://unctad.org/topic/least-developed-countries/list" target="_blank">the United Nations LDC list</a><br>
                ** Seniors must be 65 or older<br>
            </p>
        </div>
        <!-- <div >
            <table border="1" class="center-container" style="border-collapse: collapse; margin: auto; font-family: 'Times New Roman', Times, serif; line-height: 40px;">
            <thead>
            <tr>
                <th>Categories</th>
                <th>On or before 1st Sep, 2024</th>
                <th>After 1st Sep, 2024</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>Full delegate</td>
                <td>3200 HKD</td>
                <td>4000 HKD</td>
            </tr>
            <tr>
                <td>Student delegate</td>
                <td>1600 HKD</td>
                <td>2000 HKD</td>
            </tr>
            <tr>
                <td>Least developed countries *</td>
                <td>1600 HKD</td>
                <td>2000 HKD</td>
            </tr>
            <tr>
                <td>Senior participant **</td>
                <td>2600 HKD</td>
                <td>3200 HKD</td>
            </tr>
            <tr>
                <td>Daily delegate</td>
                <td>1800 HKD</td>
                <td>2200 HKD</td>
            </tr>
            <tr>
                <td>Government delegate</td>
                <td> - </td>
                <td>2600 HKD</td>
            </tr>
            <tr>
                <td>Accompanying person</td>
                <td>800 HKD</td>
                <td>1000 HKD</td>
            </tr>
            <tr>
                <td>Gala dinner</td>
                <td colspan="2">600 HKD</td>
            </tr>
            <tr>
                <td>Workshop</td>
                <td>Free</td>
                <td>TBD</td>
            </tr>
            </tbody>
            
            </table>
            <br>
            <p style="text-align: left;">
                * Persons from countries on <a href="https://unctad.org/topic/least-developed-countries/list" target="_blank">the United Nations LDC list</a><br>
                ** Seniors must be 65 or older<br>
            </p>
        </div> -->
        <TitlePart text="Register & Payment" />
        <div>
            <p style="text-align: left">
                If you would like to register as any one of the above categories, please
                <b><a href="https://cems.polyu.edu.hk/register?id=D223BC04-6926-4D47-AC73-A1FAAB1451DD"
                        target="_blank">CLICK HERE</a></b>. It is highly recommended that you kindly check the selection
                on the
                opened webpage based on the category and the project you want to attend.
            </p>
            <p style="text-align: left">
                <strong>Payment Methods: </strong><br />
                1. Visa / MasterCard Credit Card<br />
                2. China UnionPay (中国银联) Debit Card / Credit Card<br />
                3. Alipay (支付宝) / Alipay HK (支付寶香港)<br />
                4. WeChat Pay (微信支付)<br />
                5. FPS (轉數快)
            </p>
            <br />
        </div>
        <TitlePart text="Registration Policy" />
        <div class="left-aligned-text" style="line-height: 150%; text-align: justify">
            1. It is expected that at least one author attends the meeting to present
            the accepted abstract.<br />
            2. Registration confirmation is subject to payment being received.<br />
            3. If participants cannot attend the conference due to a rejected visa
            application or other uncontrollable causes, the registration fee is
            partially refundable, excluding the credit card processing fee. If you are
            not able to attend due to personal reasons, the registration fee is not
            refundable.
        </div>
        <br />
        <br />
        <br />
    </div>
</template>

<script>
import TitlePart from "@/components/TitlePart/TitlePart.vue";
export default {
    components: {
        TitlePart,
    },
};
</script>

<style lang="less" scoped>
@import "./style.less";
</style>